module.exports = __webpack_public_path__ + "static/assets/50ddcf0916dbb4133135eb02da85863d.svg";